import React, { useState } from 'react';
import { MicIcon, CloseIcon, ShieldIcon, CheckIcon } from './icons';

const ConsentScreen = ({ onConsent, onCancel }) => {
  const [consentConfirmed, setConsentConfirmed] = useState(false);

  return (
    <div className="fixed inset-0 bg-white flex flex-col" style={{ height: '100dvh' }}>
      {/* Header — compact */}
      <div className="px-4 pt-3 pb-2 flex items-center justify-between flex-shrink-0">
        <button onClick={onCancel} className="p-2 -ml-2 rounded-full active:bg-black/5 text-slate-400">
          <CloseIcon />
        </button>
        <span className="text-xs font-medium text-slate-400 uppercase tracking-wide">Before You Record</span>
        <div className="w-10" />
      </div>

      {/* Content — fills remaining space, vertically centered */}
      <div className="flex-1 flex flex-col items-center justify-center px-6 min-h-0">
        <div className="w-full max-w-sm">
          <div className="w-14 h-14 bg-gradient-to-br from-amber-100 to-orange-100 rounded-xl flex items-center justify-center mx-auto mb-4">
            <ShieldIcon className="w-7 h-7 text-amber-600" />
          </div>

          <h1 className="text-xl font-bold text-slate-900 text-center mb-2">
            Provider Consent
          </h1>

          <p className="text-sm text-slate-500 text-center mb-6 leading-relaxed">
            Confirm your provider has agreed to be recorded.
          </p>

          <button
            onClick={() => setConsentConfirmed(!consentConfirmed)}
            className={`w-full rounded-2xl p-4 border-2 transition-all mb-5 text-left active:scale-[0.98] ${
              consentConfirmed
                ? 'bg-teal-50 border-teal-300'
                : 'bg-white border-slate-200'
            }`}
          >
            <div className="flex items-center gap-3">
              <div
                className={`w-6 h-6 rounded-lg border-2 flex items-center justify-center flex-shrink-0 transition-all ${
                  consentConfirmed
                    ? 'bg-teal-500 border-teal-500 text-white'
                    : 'border-slate-300 bg-white'
                }`}
              >
                {consentConfirmed && <CheckIcon />}
              </div>
              <div className="flex-1">
                <p className={`font-semibold text-sm ${consentConfirmed ? 'text-teal-900' : 'text-slate-800'}`}>
                  My provider gave permission to record
                </p>
              </div>
            </div>
          </button>

          <button
            onClick={() => consentConfirmed && onConsent()}
            disabled={!consentConfirmed}
            className={`w-full py-4 rounded-2xl font-semibold text-base transition-all flex items-center justify-center gap-2.5 ${
              consentConfirmed
                ? 'bg-gradient-to-r from-teal-500 to-cyan-500 text-white shadow-lg shadow-teal-500/25 active:scale-[0.98]'
                : 'bg-slate-100 text-slate-400 cursor-not-allowed'
            }`}
          >
            <MicIcon className="w-5 h-5" />
            Start Recording
          </button>
        </div>
      </div>

      {/* Footer — minimal */}
      <div className="px-6 pb-6 pt-2 flex-shrink-0 text-center">
        <p className="text-[11px] text-slate-400">
          Recording without consent may violate privacy laws.
        </p>
      </div>
    </div>
  );
};

export default ConsentScreen;
